<template>
    <div class="container">
        <div class="main">
            <div class="wechat-icon">
                <svg t="1770020114246" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="3981" width="48" height="48">
                    <path
                        d="M503.552 406.95808c16.89088 0 27.648-10.84928 27.648-27.13088 0-17.05472-10.75712-27.13088-27.648-27.13088-16.128 0-31.488 10.07616-31.488 27.13088 0 16.28672 15.36 27.13088 31.488 27.13088zM351.48288 352.69632c-16.12288 0-33.024 10.07616-33.024 27.13088 0 16.2816 16.896 27.136 33.024 27.136 15.36 0 27.648-10.8544 27.648-27.136 0.00512-17.05472-12.28288-27.13088-27.648-27.13088zM574.20288 511.616c-10.752 0-21.504 10.07104-21.504 22.48192 0 10.07104 10.752 20.1472 21.504 20.1472 16.128 0 27.648-10.07616 27.648-20.1472 0.00512-12.40576-11.51488-22.48192-27.648-22.48192zM694.77888 511.616c-11.51488 0-21.504 10.07104-21.504 22.48192 0 10.07104 9.984 20.1472 21.504 20.1472 15.36 0 26.88512-10.07616 26.88512-20.1472 0-12.40576-11.52512-22.48192-26.88512-22.48192z"
                        fill="#2AAE67" p-id="3982"></path>
                    <path
                        d="M849.92 51.2H174.08c-67.8656 0-122.88 55.0144-122.88 122.88v675.84c0 67.8656 55.0144 122.88 122.88 122.88h675.84c67.8656 0 122.88-55.0144 122.88-122.88V174.08c0-67.8656-55.0144-122.88-122.88-122.88zM422.912 632.54016c-28.416 0-49.15712-4.64896-76.03712-12.40576l-77.568 39.54176 22.27712-66.66752C237.06112 554.25536 204.8 505.41056 204.8 445.7216c0-105.42592 98.304-186.04032 218.112-186.04032 105.984 0 200.45312 63.5648 218.88 153.49248-7.68-1.55648-14.592-2.3296-20.736-2.3296-104.44288 0-185.08288 79.06816-185.08288 174.4128 0 16.27648 2.304 31.00672 6.144 46.5152-6.144 0.768-13.06112 0.768-19.20512 0.768z m320.25088 75.96544l15.36 55.81312-58.368-33.3312c-22.26688 4.64896-43.776 11.62752-66.04288 11.62752-102.912 0-184.32-71.31648-184.32-159.68256s81.408-159.68768 184.32-159.68768c97.536 0 185.088 71.31648 185.088 159.68768 0 49.60768-33.024 93.78816-76.03712 125.57312z"
                        fill="#2AAE67" p-id="3983"></path>
                </svg>
            </div>
            <!-- <h1>微信授权登录</h1> -->
            <p class="description">请使用微信扫码授权</p>

            <button class="btn" @click="handleWeChatAuth()">打开微信</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            params: ""
        }
    },
    mounted() {
        let loca = window.location;
        let href = loca.href;

        // 获取所有参数
        this.params = href.split("?")[1];
    },
    methods: {
        // 打开微信小程序
        handleWeChatAuth() {
            let url = `weixin://dl/business/?appid=wxfe387d94206fe0d7&path=pages/index/index&query=${decodeURIComponent(
                this.params,
            )}&env_version=`;
            // trial
            window.location.href = url;
        }
    }
}

</script>


<style scoped>
body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
        "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    padding: 30px;
}

.main {
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 50px 40px;
    text-align: center;
    max-width: 420px;
    width: 100%;
}

.wechat-icon {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 12px;
    font-size: 28px;
    font-weight: 300;
}

h1 {
    color: #1a1a1a;
    margin-bottom: 16px;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0.5px;
}

.description {
    color: #666;
    margin-bottom: 36px;
    line-height: 1.7;
    font-size: 15px;
    font-weight: 300;
}

.btn {
    background: #07c160;
    color: white;
    border: none;
    padding: 14px 36px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.25s ease;
    margin-bottom: 28px;
    display: inline-block;
    letter-spacing: 0.5px;
}

.btn:hover {
    background: #06ad56;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.2);
}

.tips {
    background: #f5f9ff;
    border-left: 3px solid #2196f3;
    padding: 20px;
    margin-top: 24px;
    text-align: left;
    border-radius: 8px;
}

.tips h3 {
    color: #333;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 500;
}

.tips ol {
    color: #666;
    font-size: 13px;
    padding-left: 18px;
}

.tips li {
    margin-bottom: 6px;
    line-height: 1.5;
}

.qr-code {
    margin: 24px 0;
    padding: 24px;
    background: #f8fbff;
    border-radius: 8px;
    border: 1px solid #e3f2fd;
}

.qr-code p {
    color: #666;
    font-size: 13px;
    margin: 0;
    line-height: 1.6;
}
</style>